import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import { TableCell } from "@material-ui/core";
import CustomStatusBox from './misc/custom-status-box';

const useStyles = makeStyles((theme) => ({
  paper: {
    border: '1px solid',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function ErrorCell(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'error-popper' : undefined;

  return (
    <TableCell style={{padding: "0"}} onMouseEnter={handleClick} onMouseLeave={handleClick}>
      <CustomStatusBox aria-describedby={id} onClick={handleClick} status='error' withIcon={true}/>
      {/* <a aria-describedby={id} onClick={handleClick} style={{textDecorationLine: 'underline'}}>error</a> */}
      <Popper id={id} open={open} placement={'right'} anchorEl={anchorEl}>
        <div className={classes.paper}>{props.children}</div>
      </Popper>
    </TableCell>
  );
}